import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { GroupPermission, GroupDTO } from './useGetGroups';

export interface CreateGroupPayload {
	name: string;
	permissions: GroupPermission[];
}

export const useCreateGroup = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (payload: CreateGroupPayload) => {
			try {
				const { data } = await api.post<GroupDTO>('/management/group/create', payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar grupo');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['groups'] });
		},
	});
};
